import { MetadataDemoWindRose } from "./DemoWindRoses";

// rerended on every keystroke 🤔
export const DefineMetadata = ({
  binsTitle,
  yUnits,
  binUnits,
  onGoBack,
  onConfirmMetadata,
  onSetYUnits,
  onSetBinsTitle,
  onSetBinUnits,
}) => {
  return (
    <div class="define-data-card">
      <h3 class="h3">Define Units &amp; Quantity</h3>
      <div class="flex flex-row">
        <div class="md:w-2/4">
          <div class="bg-gray-300 px-6 py-4 my-4 rounded shadow">
            <label class="font-semibold" for="yUnit" title="The unit of the radial axis">
              Y-axis unit
            </label>
            <input
              id="yUnit"
              onChange={onSetYUnits}
              class="input"
              type="text"
              placeholder="Hours, occurences, frequency, %"
            />
          </div>

          <div class="bg-gray-300 px-6 py-4 my-4 rounded shadow">
            <label
              class="font-semibold"
              for="bin-title"
              title="The quantity of the bins"
            >
              Bin title
            </label>
            <input
              id="bin-title"
              onChange={onSetBinsTitle}
              class="input"
              type="text"
              placeholder="Wind speed"
            />
          </div>

          <div class="bg-gray-300 px-6 py-4 my-4 rounded shadow">
            <label class="font-semibold" for="binUnits">
              Units
            </label>
            <input
              id="binUnits"
              onChange={onSetBinUnits}
              class="input"
              type="text"
              placeholder="m/s"
            />
          </div>
        </div>

        <div class="md:w-2/4 p-6">
          <MetadataDemoWindRose
            binsTitle={binsTitle}
            yUnits={yUnits}
            binUnits={binUnits}
          />
        </div>
      </div>

      <div class="flex justify-end pt-2">
        <button class="btn btn-blue ml-4" onClick={onGoBack}>
          Go back
        </button>
        <button class="btn btn-blue ml-4" onClick={onConfirmMetadata}>
          Confirm
        </button>
      </div>
    </div>
  );
};